import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';
import { components } from './components';

export const NdSklad = {
	name: NAME,
	components,
	apiProvider,
	router,
};
